import cx from 'classnames'

type Props = {
  value?: number | null
  onChange?: (value: number | null) => void
  min?: number
  max?: number
  precision?: number
  step?: number
  disabled?: boolean
  placeholder?: string
  style?: React.CSSProperties
  className?: string
  id?: string
  size?: string
  'data-cy'?: string
  'data-testid'?: string
  // antd InputNumber compat: formatter/parser accepted but not applied
  formatter?: (value: number | string | undefined) => string
  parser?: (value: string | undefined) => string | number
  decimalSeparator?: string
}

const NumberInput = ({
  value,
  onChange,
  min,
  max,
  step,
  disabled = false,
  placeholder,
  style,
  className,
  id,
  'data-cy': dataCy,
  'data-testid': dataTestId,
}: Props) => {
  return (
    <input
      type="number"
      className={cx(
        'updated-component border border-gray-300 rounded px-2 h-10 text-sm',
        'focus:outline-none focus:border-maroon-400',
        className
      )}
      style={style}
      id={id}
      value={value !== undefined && value !== null ? value : ''}
      min={min}
      max={max}
      step={step}
      onChange={(e) => {
        const raw = e.target.value
        onChange?.(raw === '' ? null : Number(raw))
      }}
      disabled={disabled}
      placeholder={placeholder}
      data-cy={dataCy}
      data-testid={dataTestId}
    />
  )
}

export default NumberInput
